<template>
  <div class="d-flex align-items-center my-4 py-2 w-100">
    <div v-if="this.data.length > 0" class="mr-4 pr-4">
      <img v-if="isCritical" class="icon-small" v-bind:src="'/app/images/icons/warning_danger.svg'" />
      <img v-else class="icon-small" v-bind:src="'/app/images/icons/warning.svg'" />
    </div>
    <div v-else class="mr-4 pr-4">
      <img class="icon-small" v-bind:src="'/app/images/icons/success.svg'" />
    </div>
    <h6 class="w-25 ml-4 mb-0">{{ this.name }}</h6>
    <p v-if="this.data.length > 0" class="mb-0">{{$t('global.alerts_conjugation')}}: {{ this.data.length }} </p>
    <p v-else class="mb-0">{{ $t('global.no_alerts') }}</p>
  </div>
</template>

<script>
export default {
  name: 'AlertTypeInfo',

  props: {
    data: { required: false, type: Array },
    name: { required: false, type: String }
  },

  computed: {
    isCritical () {
      if (this.data.some(alert => alert.level === 0)) return true
      else return false
    }
  }
}
</script>
